var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, Box } from "@mui/material";
import { Text } from "../../../../Atoms";
import StepIndicator from "../StepIndicator";
import StepLine from "../StepLine";
var ellipsis = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
};
var Step = function (_a) {
    var step = _a.step, idx = _a.idx, currentStep = _a.currentStep, previousStep = _a.previousStep, lastStep = _a.lastStep;
    /** show additional text if
     * - user is not on last step
     * - the step is complete
     * - the user is not on this step
     **/
    var showAdditionalText = currentStep !== lastStep &&
        (step.additionalText || step.additionalText === "") &&
        step.complete &&
        idx !== currentStep;
    return (_jsxs(_Fragment, { children: [_jsx(StepLine, { currentStep: currentStep, complete: step.complete, idx: idx, previousStep: previousStep }), _jsxs(Box, __assign({ sx: {
                    cursor: step.onClick && currentStep !== idx ? "pointer" : null,
                }, onClick: currentStep !== idx ? step.onClick : undefined }, { children: [_jsx(StepIndicator, { step: step, idx: idx, currentStep: currentStep, previousStep: previousStep }), _jsxs(Stack, __assign({ sx: {
                            position: "absolute",
                            top: 22,
                            pt: 2,
                            transform: "translateX(-50%)",
                            textAlign: "center",
                            ml: 3,
                            px: 1.5,
                            width: "".concat(Math.round(100 / (lastStep + 1)), "%"),
                        } }, { children: [_jsx(Text, __assign({ variant: currentStep === idx ? "subtitle2" : "body2", emphasis: !(previousStep === null || previousStep === void 0 ? void 0 : previousStep.complete) && idx > currentStep && !step.complete
                                    ? "disabled"
                                    : "high", sx: ellipsis }, { children: step.stepName })), showAdditionalText && (_jsx(Text, __assign({ variant: "body2", emphasis: "medium", sx: ellipsis }, { children: step.additionalText || undefined }), idx))] }), idx)] }))] }));
};
export default Step;
